import { render, staticRenderFns } from "./code116.vue?vue&type=template&id=13b0a831&scoped=true"
import script from "./code116.vue?vue&type=script&lang=js"
export * from "./code116.vue?vue&type=script&lang=js"
import style0 from "./code116.vue?vue&type=style&index=0&id=13b0a831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0a831",
  null
  
)

export default component.exports